
const messages = {
    en: {
        translations: {
            titles: {
                app: 'My Application'
            },
            messages: {
                itWorks: 'It works with multi languages.',
                smallText: 'A small text',
            },
            buttons: {
                save: 'Save'
            }
        }
    }
}


export { messages };
